import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, Section, Loading } from "../components/Common";
import { MapPin, Radar } from "lucide-react";
import { toast } from "sonner";

export default function Transport() {
  const [routes, setRoutes] = useState(null);
  const [gpsByRoute, setGpsByRoute] = useState({});
  useEffect(() => { api.transportRoutes().then(({ data }) => setRoutes(data)); }, []);
  const pingGps = async (routeId) => {
    try { const { data } = await api.transportGps(routeId); setGpsByRoute((p) => ({ ...p, [routeId]: data })); }
    catch { toast.error("GPS unavailable"); }
  };
  if (routes === null) return <Loading />;
  return (
    <div data-testid="transport-page">
      <PageHeader kicker="Transport" title="School Buses & Routes" subtitle="Fleet management, route coverage and Live GPS placeholders (production-ready for real telematics)." />
      <Section>
        <DataTable
          columns={[
            { key: "name", label: "Route" },
            { key: "driver_name", label: "Driver" },
            { key: "driver_phone", label: "Contact", render: (r) => <span className="mono text-xs">{r.driver_phone}</span> },
            { key: "vehicle", label: "Vehicle" },
            { key: "capacity", label: "Capacity" },
            { key: "stops", label: "Stops", render: (r) => (r.stops || []).length },
          ]}
          rows={routes}
        />
      </Section>
      {routes.map((r) => (
        <div key={r.id} className="hl-card p-5 mb-4">
          <div className="grid md:grid-cols-3 gap-4">
            <div className="md:col-span-2">
              <div className="overline">Route</div>
              <div className="font-display font-bold text-lg tracking-tight">{r.name}</div>
              <div className="mt-3 flex flex-wrap gap-2">
                {(r.stops || []).map((s, i) => (
                  <div key={i} className="text-xs bg-slate-50 border border-slate-200 rounded-md px-3 py-1.5">
                    <div className="font-semibold">{s.name}</div>
                    <div className="text-slate-500 mono">{s.time}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="hl-card p-4 bg-gradient-to-br from-slate-50 to-white" data-testid={`gps-${r.id}`}>
              <div className="flex items-center justify-between mb-2">
                <div className="overline"><MapPin className="w-3 h-3 inline mr-1" /> Live GPS</div>
                <button onClick={() => pingGps(r.id)} data-testid={`gps-ping-${r.id}`} className="text-xs text-[color:var(--hl-orange)] hover:underline inline-flex items-center gap-1">
                  <Radar className="w-3 h-3" /> Ping
                </button>
              </div>
              {gpsByRoute[r.id] ? (
                <div className="text-xs text-slate-600 space-y-1">
                  <div>Status: <span className="font-semibold text-amber-600 uppercase tracking-widest">{gpsByRoute[r.id].status}</span></div>
                  <div>ETA: <span className="mono font-semibold">{gpsByRoute[r.id].sample.eta_minutes} min</span></div>
                  <div>Speed: <span className="mono font-semibold">{gpsByRoute[r.id].sample.speed_kph} km/h</span></div>
                  <div>Distance: <span className="mono font-semibold">{gpsByRoute[r.id].sample.bearing_to_school_km} km</span></div>
                  <div className="text-[10px] text-slate-400 mt-2">{gpsByRoute[r.id].message}</div>
                </div>
              ) : (
                <div className="text-xs text-slate-500">Awaiting first ping. Provider slot reserved — plug in Samsara / Verizon Connect / Geotab here.</div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
